import { DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES } from '@/constants';

export default {
  ticketUrlAndId: 'URL et identifiant du ticket',
  ticketUrlAndIdHelpText: 'L\'URL du ticket reçue de la réponse de l\'API peut être ajoutée aux informations dynamiques de l\'alarme.',
  dataFromOneStepAttention: 'Les données de la réponse de l\'API ne peuvent être extraites que d\'une étape d\'une règle.',
  ticketID: 'ID de ticket',
  ticketURL: 'URL du ticket',
  ticketURLTitle: 'Titre de l\'URL du ticket',
  ticketURLTitleHelp: 'TCe titre s\'affichera dans le corps de la balise de lien : <strong>&lt;a href=&quot;{URL}&quot;&gt;{TITLE}&lt;/a&gt;</strong>',
  ticketSystemName: 'Nom du système de ticket',
  allowTicketURLTemplate: 'Autoriser les variables dans l\'URL',
  allowTicketIdTemplate: 'Autoriser les variables dans l\'ID',
  alarmFieldName: 'Nom du champ d\'alarme',
  responseField: 'Champ de réponse',
  responseFieldHelpText: 'Champ de réponse API au format JSON d\'où provient le "{field}"',
  emptyResponse: 'Réponse vide',
  isRegexp: 'La valeur peut être une expression régulière',
  addWebhook: 'Ajouter un webhook',
  emptyFields: 'Aucun champ ajouté pour le moment',
  emptyWebhooks: 'Aucun webhook ajouté pour le moment',
  workflowIfStepFails: 'Si cette étape échoue',
  continueWithNextStep: 'Continuer avec les étapes suivantes',
  webhookTicketDeclarationExist: 'La déclaration de ticket Webhook existe déjà dans une autre étape',
  headerFieldFromPreviousSteps: 'Champ d\'en-tête des étapes précédentes',
  responseFieldFromStep: 'Champ de réponse de l\'étape #N',
  responseFieldFromPreviousSteps: 'Champ de réponse des étapes précédentes',
  userId: 'Identifiant d\'utilisateur',
  actionInitiator: 'Initiateur d\'actions',
  triggerEventMessage: 'Déclencher un message d\'événement',
  noRulesForAlarms: 'Aucune règle à appliquer pour les alarmes sélectionnées',
  oneTicketForAlarms: 'Un ticket pour toutes les alarmes',
  applyRules: 'Appliquer les règles',
  noAckItems: 'Il y a {count} élément sans acquittement. L\'événement d\'acquittement pour l\'élément sera envoyé avant. | Il y a {count} éléments sans acquittement. Les événements d\'acquittement pour les éléments seront envoyés avant.',
  ruleName: 'Nom de la règle',
  checkSyntax: 'Vérifier la syntaxe',
  syntaxIsValid: 'La syntaxe est valide',
  ticketResources: 'Déclarer un ticket pour les ressources',
  massRemove: 'Supprimer les règles de déclaration de ticket',
  massEnable: 'Activer les règles de déclaration de ticket',
  massDisable: 'Désactiver les règles de déclaration de ticket',
  checkTicketStatus: 'Vérifier le statut du ticket',
  checkTicketStatusHelpText: 'Activer pour vérifier que le ticket existe dans le système de tickets avant d\'exécuter les étapes suivantes.',
  ticketStatusMapping: 'Correspondance des statuts de ticket',
  ticketStatusMappingHelpText: 'Au moins une valeur source doit être mappée vers la valeur Canopsis « Fermé ».',
  ticketStatusMappingUnmappedToOpen: 'Toutes les valeurs sources non mappées seront mappées au statut Canopsis « Inconnu ».',
  sourceValue: 'Valeur source',
  canopsisValue: 'Valeur Canopsis',
  addMappingPair: 'Ajouter une paire de correspondance',
  ticketStatusSourceField: 'Champ source du statut du ticket',
  allowTicketStatusSourceTemplate: 'Autoriser les variables dans le champ source du statut du ticket',
  reuseHeadersAndAuthFromTicketDeclarationRule: 'Réutiliser les en-têtes et l\'authentification de la règle de déclaration de ticket',
  status: {
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.unknown]: 'Inconnu',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.open]: 'Ouvert',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.assigned]: 'Assigné',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.inProgress]: 'En cours',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.closed]: 'Fermé',
  },
  errors: {
    webhookRequired: 'Les webhooks doivent être ajoutés',
    webhookTicketDeclarationRequired: 'Une déclaration de ticket webhook doit être définie',
    ticketRequired: 'Un ticket doit être ajouté',
    statusMappingRequired: 'Au moins une paire de correspondance doit être ajoutée',
  },
};
